// music.js

const state = {
    open: false,
};

const mutations = {
    setOpen(state, status) {
        state.open = status;
    }
};

const actions = {
    handleVisible({ commit }, status) {
        commit('setOpen', status);
    }
};

const getters = {
    isOpen: state => state.open,
};

export default {
    namespaced: true, 
    state,
    mutations,
    actions,
    getters 
};